// import jsPDF from "jspdf";
// import moment from "moment";
// import employeeLogo from "../../images/employee.png";

// function GatPassPrint({ items, search }) {
//   let doc = new jsPDF();

//   doc.setFontSize(10);
//   doc.setFontSize(18);
//   doc.text(localStorage.getItem("company"), 50, 22);

//   doc.setFontSize(26);

//   doc.text("GATE PASS", 120, 22);

//   doc.setFontSize(12);
//   doc.setFontStyle("normal");

//   doc.text("Start Date:", 130, 55);
//   doc.text(moment(search.startDate).format("DD-MM-YYYY"), 160, 55);
//   doc.text("End Date:", 130, 63);
//   doc.text(moment(search.endDate).format("DD-MM-YYYY"), 160, 63);

//   doc.setFontSize(12);
//   doc.text("Shop", 21, 58);

//   doc.setFontStyle("normal");
//   doc.text(localStorage.getItem("company") || "", 20, 65);
//   doc.text(localStorage.getItem("address") || "", 20, 72);
//   doc.text(localStorage.getItem("phone") || "", 20, 79);

//   let img = new Image();

//   let baseUrl = localStorage.getItem("base_url");

//   if (baseUrl == undefined || baseUrl == "" || baseUrl == null) {
//     let snapshot = employeeLogo;
//     img.src = snapshot;
//   } else {
//     let snapshot = localStorage.getItem("base_url");
//     img.src = snapshot;
//   }
//   doc.addImage(img, "png", 0, 0, 40, 40);
//   jsPDF.autoTableSetDefaults({
//     theme: "plain",
//     headStyles: { fontStyle: "bold" },

//     margin: { left: 8, right: 8, bottom: 10 },
//     bodyStyles: { color: "rgba(0, 0, 0, 0.87)", fontStyle: "bold" },
//   });
//   let col = ["#", "Item", "Sale Qty", "Sale Amount"];
//   let rows = [];
//   let Total = 0;
//   items.map((item, index) => {
//     Total += parseFloat(item.saleAmount);
//     doc.setFontSize(14);
//     let temp = [
//       index + 1,
//       item.itemName,
//       parseInt(item.saleQuantity),
//       item.saleAmount,
//     ];
//     rows.push(temp);
//   });

//   doc.autoTable(col, rows, { startY: 100 });

//   let finalY = doc.lastAutoTable.finalY;
//   doc.setFontSize(14);
//   doc.text("Total", 120, finalY + 16);
//   doc.text(Total.toString(), 155, finalY + 16);

//   doc.setFontSize(10);
//   doc.text("Powered by www.managekaro.pk", 84, 285);
//   doc.text("0331 5921209", 95, 290);

//   doc.setFontSize(10);
//   if (window.innerWidth <= 600) {
//     doc.save("reciept");
//   } else {
//     doc.autoPrint();
//     window.open(doc.output("bloburl"), "_blank");
//   }
// }

// export default GatPassPrint;


import moment from "moment";
import employeeLogo from "../../images/employee.png";
import html2pdf from "html2pdf.js";

function GatPassPrint({ items, search }) {
  // Calculate total sale amount
  const totalAmount = items.reduce((total, item) => total + parseFloat(item.saleAmount), 0);

  // HTML structure for Gate Pass report
  const htmlContent = document.createElement("div");
  htmlContent.innerHTML = `
    <div style="padding: 10px; font-family: Arial, sans-serif; max-width: 600px;">
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
        <img src="${localStorage.getItem("base_url") || employeeLogo}" width="40" height="40" alt="Company Logo"/>
        <h2 style="text-align: center;">${localStorage.getItem("company")}</h2>
        <h1 style="text-align: center; font-size: 24px;">GATE PASS</h1>
      </div>

      <div style="margin-bottom: 10px;">
        <p><strong>Start Date:</strong> ${moment(search.startDate).format("DD-MM-YYYY")}</p>
        <p><strong>End Date:</strong> ${moment(search.endDate).format("DD-MM-YYYY")}</p>
      </div>
      
      <div style="margin-bottom: 10px;">
        <p><strong>Shop:</strong> ${localStorage.getItem("company") || ""}</p>
        <p>${localStorage.getItem("address") || ""}</p>
        <p>${localStorage.getItem("phone") || ""}</p>
      </div>
      
      <table style="width: 100%; border-collapse: collapse; margin-top: 20px;">
        <thead>
          <tr style="background-color: #f2f2f2;">
            <th style="padding: 8px; border: 1px solid #ddd;">#</th>
            <th style="padding: 8px; border: 1px solid #ddd;">Item</th>
            <th style="padding: 8px; border: 1px solid #ddd;">Sale Qty</th>
            <th style="padding: 8px; border: 1px solid #ddd;">Sale Amount</th>
          </tr>
        </thead>
        <tbody>
          ${items
            .map((item, index) => `
              <tr>
                <td style="padding: 8px; border: 1px solid #ddd;">${index + 1}</td>
                <td style="padding: 8px; border: 1px solid #ddd;">${item.itemName}</td>
                <td style="padding: 8px; border: 1px solid #ddd;">${parseInt(item.saleQuantity)}</td>
                <td style="padding: 8px; border: 1px solid #ddd;">${item.saleAmount}</td>
              </tr>`)
            .join("")}
        </tbody>
      </table>
      
      <p style="text-align: right; font-weight: bold; margin-top: 10px;">Total: ${totalAmount}</p>

    </div>
  `;

  // PDF options
  const options = {
    margin: 0.5,
    filename: "gate_pass_report.pdf",
    image: { type: "png", quality: 0.98 },
    html2canvas: { scale: 2 },
    jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
  };

  // Generate PDF and open it in a new tab
  html2pdf()
    .from(htmlContent)
    .set(options)
    .output("blob")
    .then((blob) => {
      const url = URL.createObjectURL(blob);
      const newWindow = window.open(url, "_blank");
      if (newWindow) {
        newWindow.onload = function () {
          setTimeout(() => {
            newWindow.print();
          }, 100);
        };
      } else {
        alert("Please allow popups for this website");
      }
    });
}

export default GatPassPrint;
